import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class DaDataSuggestRequestQuery
*  Query params for operation "DaDataSuggest"
*/
export class DaDataSuggestRequestQuery extends ActiveModel {

/**
  * query
  * 
  */
  @ActiveField()
  query?: string


/**
  * city
  * 
  */
  @ActiveField()
  city?: string


/**
  * region
  * 
  */
  @ActiveField()
  region?: string


  /**
  * count
  *   */
  @ActiveField()
  count?: number
}
